import { t } from "@impero-com/common/utils/i18n";
import { emitNotification } from "@impero-com/ui";
import * as Sentry from "@sentry/react";

import { usePostBlobsDuplicate } from "api/generated/blobs/blobs";

export const useCopyBlobsMutation = () =>
    usePostBlobsDuplicate({
        mutation: {
            onError: (err) => {
                emitNotification("error", t("File_Copy_Failed"));
                Sentry.captureException(err);
            },
        },
    });
